// src/modules/operaciones/inventarios/components/Badge.js
import React from "react"; // Importa React para usar JSX

const TONOS_BADGE = { gray: "badgeGray", blue: "badgeBlue", green: "badgeGreen", red: "badgeRed", amber: "badgeAmber" }; // Mapea tono → clave de clase en el tema

// Etiqueta pequeña de color (estado, alerta, bodega)
const Badge = ({ tema, tono = "gray", cuadrado, children, pulse }) => {
  const clase = tema[TONOS_BADGE[tono]] || tema.badgeGray; // Clase según el tono, gris por defecto
  return (
    // Span con bordes redondeados o cuadrados y animación pulse opcional
    <span
      className={`inline-flex items-center px-2 py-0.5 ${cuadrado ? "rounded-lg" : "rounded-full"} border text-[10px] font-bold ${clase} ${
        pulse ? "animate-pulse" : ""
      }`}
    >
      {children}
    </span>
  );
};

export default Badge;